import React, { useEffect } from "react";
import naver from "assets/images/naver.png";
import kakao from "assets/images/kakao.png";
import google from "assets/images/google.png";
import apple from "assets/images/apple.png";
import { useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routes } from "routes";
import { getOauthUrls, postAdInfo } from "services/apis";
import { signInUsingToken } from "services/authService";
import { getGaClientId } from "utils/utils";

const LoginButtons = ({ onClickIdLogin }) => {
  const [searchParams] = useSearchParams();
  const redirectURI = decodeURIComponent(searchParams.get("redirectURI"));
  // const preventAdInfo = useRef(false);

  const { data: urls } = useQuery("auth-oauth-urls", () => {
    return getOauthUrls().then(({ data }) => {
      return data;
    });
  });

  const options =
    "width = 500, height = 500, left = 100, top = 100, scrollbar = no, location = no, toolbars = no, status = no";

  const navigate = useNavigate();
  const handleClickLogin = async (type) => {
    if (urls[type]) {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      // macOS Safari 감지 (Chrome 등 다른 브라우저 제외)
      const isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !isIOS;
      if (type === "APPLE" && (isIOS || isSafari)) {
        // Safari(iOS/macOS)는 Apple OAuth 시 response_mode=form_post와 COOP 헤더로
        // 인해 팝업의 window.opener가 null이 되어 콜백이 메인 창으로 들어옴
        // 처음부터 현재 창을 리다이렉트하여 처리
        sessionStorage.setItem("apple_ios_redirect", "true");
        window.location.href = urls[type];
      } else {
        window.open(urls[type], "simple 로그인", options);
      }
    }
  };

  useEffect(() => {
    async function postMessageCatcher(event) {
      if (event.origin !== window.location.origin) return;
      if (event.data.type === "simple_login") {
        const clientId = getGaClientId();
        let token = event.data.accessToken;
        await signInUsingToken(
          token,
          navigate,
          redirectURI,
          "로그인되었습니다.",
        );
        await postAdInfo({ ga_instance: clientId });
      } else if (event.data.type === "signup_required") {
        navigate(routes.authSignUpAcceptTerms, {
          state: { requestId: event.data.requestId },
        });
      }
    }
    window.addEventListener("message", postMessageCatcher, false);
    return () => {
      window.removeEventListener("message", postMessageCatcher);
    };
  }, [navigate, redirectURI]);

  // Safari 생체 인증(Face ID/Touch ID) 시 window.opener가 null이 되어 postMessage 대신
  // localStorage를 통해 토큰을 전달받는 경우를 처리
  useEffect(() => {
    async function handleSimpleLoginToken(token) {
      localStorage.removeItem("simple_login_token");
      const clientId = getGaClientId();
      await signInUsingToken(token, navigate, redirectURI, "로그인되었습니다.");
      await postAdInfo({ ga_instance: clientId });
    }

    // 마운트 시 잔류 토큰 처리 (storage 이벤트를 놓친 경우 방어)
    const residual = localStorage.getItem("simple_login_token");
    if (residual) {
      handleSimpleLoginToken(residual);
    }

    const residualSignup = localStorage.getItem("simple_signup_requestId");
    if (residualSignup) {
      localStorage.removeItem("simple_signup_requestId");
      navigate(routes.authSignUpAcceptTerms, { state: { requestId: residualSignup } });
    }

    async function storageCatcher(event) {
      if (event.key === "simple_login_token" && event.newValue) {
        handleSimpleLoginToken(event.newValue);
      } else if (event.key === "simple_signup_requestId" && event.newValue) {
        localStorage.removeItem("simple_signup_requestId");
        navigate(routes.authSignUpAcceptTerms, { state: { requestId: event.newValue } });
      }
    }
    window.addEventListener("storage", storageCatcher, false);
    return () => {
      window.removeEventListener("storage", storageCatcher);
    };
  }, [navigate, redirectURI]);

  return (
    <>
      <div className="login_sns">
        <p className="sns_login_title"> 간편 로그인 </p>
        <div className="sns_button">
          <button
            className="naver_bt pointer"
            onClick={() => handleClickLogin("NAVER")}
          >
            <img src={naver} alt="" /> 네이버로 로그인
          </button>
          <button
            className="kakao_bt pointer"
            onClick={() => handleClickLogin("KAKAO")}
          >
            <img src={kakao} alt="" /> 카카오톡으로 로그인
          </button>
          <button
            className="google_bt pointer"
            onClick={() => handleClickLogin("GOOGLE")}
          >
            <img src={google} alt="" /> 구글로 로그인
          </button>
          <button
            className="apple_bt pointer"
            onClick={() => handleClickLogin("APPLE")}
          >
            <img src={apple} alt="" /> 애플로 로그인
          </button>
        </div>
      </div>
      <div className="login_kb">
        <button onClick={onClickIdLogin} className="pointer">
          아이디로 로그인
        </button>
      </div>
    </>
  );
};

export default LoginButtons;
